import React from 'react';
import {Checkbox, TextField} from "@fluentui/react";
import CatalogDropdown from "./CatalogDropdown";
import { useGetSearchSettingsQuery } from '../../store/endpoints/SearchSettingsEndpoints';
import { RootState } from '../../store/rootReducer';
import { useSelector } from 'react-redux';
import { useMsal } from '@azure/msal-react';

interface ISearchSerttingsSelectionProps {
    desiredQuantity?: number;
    onDesiredQuantityChange: (desiredQuantity: number | undefined) => void;
    allKeywords: boolean;
    onAllKeywords: (allKeywords: boolean) => void;
    includeAllConfigurations?: boolean;
    onIncludeAllConfigurations?: (includeAll: boolean) => void;
}

const SearchSettingsSelection: React.FC<ISearchSerttingsSelectionProps> = (props) => {
    const org = useSelector((state: RootState) => state.settings.selectedOrganization);
    const user = useMsal().accounts[0]?.username;
    const [desiredQuantity, setDesiredQuantity] = React.useState<string | undefined>();
    const [allKeywords, setAllKeywords] = React.useState<boolean>(false);
    const [includeAllConfigurations, setIncludeAllConfigurations] = React.useState<boolean>(false);
    const searchSettings = useGetSearchSettingsQuery({org: org ?? '', user});

    React.useEffect(() => {
        setDesiredQuantity(props.desiredQuantity?.toString());
        setAllKeywords(props.allKeywords)
        setIncludeAllConfigurations(props.includeAllConfigurations ?? false);
    }, [props.desiredQuantity, props.allKeywords]);

    const changeQuantity = (value: string) => {
        if (value === '') {
            setDesiredQuantity('');
            props.onDesiredQuantityChange(undefined);
        } else {
            const parsed = parseInt(value);
            if (isNaN(parsed)) {
                setDesiredQuantity('');
                props.onDesiredQuantityChange(undefined);
            } else {
                props.onDesiredQuantityChange(parseInt(value));
            }
        }

    }

    const blurQuantity = (event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const value = event.target.value;
        changeQuantity(value);
    }

    const quantityKeyPress = (event: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        if (event.key === 'Enter') {
            const value = (event.target as HTMLInputElement).value;
            changeQuantity(value);
        }
    }
    
    const changeKeywordSelection = (change: boolean) => {
        setAllKeywords(change);
        props.onAllKeywords(change);
    }

    const includeAllConfigurationsChange = (change: boolean) => {
        setIncludeAllConfigurations(change);
        props.onIncludeAllConfigurations?.(change);
    }

    return (<>
        <CatalogDropdown showLabel/>
        {searchSettings.data?.showDesiredQuantity && <TextField
            label={'Desired Quantity'}
            value={desiredQuantity}
            onChange={(e,d) => setDesiredQuantity(d)}
            onBlur={blurQuantity}
            onKeyDown={quantityKeyPress}
            />}
        <div style={{paddingTop: '1em'}}>
            <Checkbox
                label='Match All Keywords'
                checked={allKeywords}
                onChange={(e,d) => changeKeywordSelection(d ?? false)}
            />
        </div>
        <div style={{paddingTop: '1em'}}>
            <Checkbox
                label='Include All Configurations'
                checked={includeAllConfigurations}
                onChange={(e, d) => includeAllConfigurationsChange(d ?? false)}
            />
        </div>
    </>);
}

export default SearchSettingsSelection;